import { BodyLong, Heading, Link, Table, VerticalSpace } from '@elhub/ds-components'

import React from 'react'
import ReactJson from 'react-json-view'

const json = {
  meta: {
    created: '2023-12-12T12:18:07+01:00'
  },
  links: {
    self: 'https://api.elhub.no/energy-data/v0/parties'
  },
  data: [
    {
      type: 'parties',
      id: '8000400000039',
      attributes: {
        gln: '8000400000039',
        partyTypes: ['BalanceResponsible'],
        name: 'BalanceResponsible Rasmussen, Hagen og Carlsen',
        organisationNumber: '455261619'
      }
    },
    {
      type: 'parties',
      id: '9200600000030',
      attributes: {
        gln: '9200600000030',
        partyTypes: ['BalanceSupplier', 'BalanceResponsible'],
        name: 'BalanceSupplier Kristiansen-Solli',
        organisationNumber: '455261619'
      }
    }
  ]
}

const attributes = [
  {
    Attribute: 'gln',
    Type: 'String',
    Description:
      'GLN of the Party. More info https://elhub.no/aktorer-og-markedsstruktur/aktorenes-roller/organisasjonsnummer-og-gln/'
  },
  {
    Attribute: 'partyTypes',
    Type: 'Array',
    Description:
      'A sub-level of the Organisation which can consist of several Parties. A Party is uniquely identified by its GLN'
  },
  { Attribute: 'name', Type: 'String', Description: 'Name of the Party' },
  {
    Attribute: 'organisationNumber',
    Type: 'String',
    Description:
      'The Organisation number of the Party. More info https://elhub.no/aktorer-og-markedsstruktur/aktorenes-roller/organisasjonsnummer-og-gln/'
  }
]

const Parties = () => {
  return (
    <>
      <Heading>Parties</Heading>
      <BodyLong size='small'>
        To query the list of parties, use the following endpoint:{' '}
        <Link variant='primary' href='https://api.elhub.no/energy-data/v0/parties'>
          https://api.elhub.no/energy-data/v0/parties
        </Link>
      </BodyLong>
      <VerticalSpace />
      <BodyLong size='small'>Sample response:</BodyLong>
      <ReactJson src={json} collapsed name={false} sortKeys />
      <VerticalSpace />
      <Table size='small'>
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeader scope='col'>Attribute</Table.ColumnHeader>
            <Table.ColumnHeader scope='col'>Type</Table.ColumnHeader>
            <Table.ColumnHeader scope='col'>Description</Table.ColumnHeader>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {attributes.map(({ Attribute, Type, Description }) => (
            <Table.Row key={Attribute}>
              <Table.HeaderCell scope='row'>{Attribute}</Table.HeaderCell>
              <Table.DataCell>{Type}</Table.DataCell>
              <Table.DataCell>{Description}</Table.DataCell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </>
  )
}

export default Parties
